module.exports = __webpack_public_path__ + "static/img/characters_long.c9f2718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters_long.png
// module id = gW+q
// module chunks = 1